// ActiveJobsPrint.jsx
import React, { useRef } from 'react';
import Moment from 'react-moment';
import { AiFillPrinter } from 'react-icons/ai';
import ReactToPrint from 'react-to-print';
import styled from 'styled-components';
import LOGO from '../Assets/plsprint.png'; // adjust path if needed
import { Button, Flexed, Flex, Wrapper } from '../utilities/Shared'; // your shared components

// Reuse your existing styled components
// (Wrapper, Flexed, Flex are already imported from your utilities)

export default function Wip({ 
  jobs, 
  activeops, 
  selectedsalesrep, 
  buttonText = "Print Active Jobs",
  buttonStyle = {} 
}) {
  const componentRef = useRef();
console.log(jobs)
  return (
    <>
      {/* Trigger Button */}
      <ReactToPrint
        trigger={() => (
          <Button
            bgcolor="#4a90e2"
            color="white"
            padding="8px 20px"
            fontSize="1.2rem"
            border="none"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              ...buttonStyle
            }}
          >
            <AiFillPrinter size={20} />
            {buttonText}
          </Button>
        )}
        content={() => componentRef.current}
        documentTitle={`Active_Jobs_${selectedsalesrep?.label || 'Rep'}_${new Date().toISOString().split('T')[0]}`}
        onBeforePrint={() => console.log('Preparing active jobs print...')}
        onAfterPrint={() => console.log('Print completed')}
      />

      {/* Hidden Printable Content */}
      <div style={{ display: 'none' }}>
        <div ref={componentRef}>
          <Wrapper style={{ background: 'white', padding: '30px 40px' }}>
            {/* Header Section - similar to your packing list */}
            <Flexed margin="0 0 25px 0" style={{ borderBottom: '2px solid #8398AB', paddingBottom: '15px' }}>
              <Flex>
                <img src={LOGO} alt="PLS Print Logo" style={{ height: '90px' }} />
              </Flex>
              <Flex flex="2" style={{ fontSize: '1.8rem', textAlign: 'center', fontWeight: 'bold' }}>
                Active Jobs Report
              </Flex>
              <Flex style={{ fontSize: '1.2rem', textAlign: 'right' }}>
                Generated on <Moment format="MM/DD/YYYY">{new Date()}</Moment><br />
                at {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}<br />
                Sales Rep: {selectedsalesrep?.label || '—'}
              </Flex>
            </Flexed>

            {/* Table Header */}
            <Flexed 
              bgColor="#8398AB" 
              color="white" 
              padding="10px 8px"
              style={{ 
                fontWeight: 'bold', 
                fontSize: '1.1rem',
                border: '1px solid #666',
                marginBottom: '1px'
              }}
            >
              <Flex>Job #</Flex>
              <Flex flex="2">Customer</Flex>
              <Flex flex=".7">Quantity</Flex>
                <Flex flex="2">Job Name</Flex>
              <Flex>Enter Date</Flex>
              <Flex>Due Date</Flex>
              <Flex>PO#</Flex>
              <Flex>Status</Flex>
            </Flexed>

            {/* Table Rows */}
            {jobs.map((jobinfo, index) => {
              const matchingOp = activeops.find(op => String(op.job) === String(jobinfo.job));
              const opName = matchingOp ? matchingOp.name : 'On Incoming';

              return (
                <Flexed
                  key={jobinfo._id || index}
                  padding="10px 8px"
                  style={{
                    borderBottom: '1px solid #ddd',
                    backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white',
                    fontSize: '1.05rem'
                  }}
                >
                  <Flex>{jobinfo?.job || '—'}</Flex>
                  <Flex flex="2">{jobinfo?.customer || '—'}</Flex>
                  <Flex flex=".7">
                    {jobinfo?.quantity 
                      ? new Intl.NumberFormat('en-US').format(Number(jobinfo.quantity)) 
                      : '—'}
                  </Flex>
                    <Flex flex="2">{jobinfo?.jobname || '—'}</Flex>
                  <Flex>
                    {jobinfo?.dateentered 
                      ? <Moment format="MM/DD/YYYY">{jobinfo.dateentered}</Moment> 
                      : '—'}
                  </Flex>
                  <Flex>
                    {jobinfo?.duedate 
                      ? <Moment format="MM/DD/YYYY">{jobinfo.duedate}</Moment> 
                      : '—'}
                  </Flex>
                  <Flex>{jobinfo?.custpo || '—'}</Flex>
                  <Flex>{opName}</Flex>
                </Flexed>
              );
            })}

            {/* Footer */}
            <Flexed margin="40px 0 0 0" style={{ fontSize: '1rem', color: '#555' }}>
              <Flex>Printed by: {sessionStorage.getItem('fullName') || '—'}</Flex>
              <Flex textAlign="right">
                Total Active Jobs: <strong>{jobs.length}</strong>
              </Flex>
            </Flexed>
          </Wrapper>
        </div>
      </div>
    </>
  );
}